import apiClient from "../http/apiClient";
import { RBAC_ENDPOINTS } from "../http/endpoints";

const detailUrl = (basePath, id) => `${basePath}${id}/`;
const userCompaniesUrl = (userId = "me") => `rbac/user-companies/${userId}/`;
const rolesByCompanyUrl = (companyId) => `rbac/roles/by-company/${companyId}/`;
const assignUserCompanyUrl = "rbac/assign-user-company/";

export async function listCompanies(params = {}) {
  const response = await apiClient.get(RBAC_ENDPOINTS.companies, { params });
  return response.data;
}

export async function createCompany(payload) {
  const response = await apiClient.post(RBAC_ENDPOINTS.companies, payload);
  return response.data;
}

export async function updateCompany(id, payload) {
  const response = await apiClient.patch(detailUrl(RBAC_ENDPOINTS.companies, id), payload);
  return response.data;
}

export async function toggleCompanyActive(id, is_active) {
  return updateCompany(id, { is_active });
}

export async function deleteCompany(id) {
  const response = await apiClient.delete(detailUrl(RBAC_ENDPOINTS.companies, id));
  return response.data;
}

export async function companiesMine(params = {}) {
  const response = await apiClient.get(RBAC_ENDPOINTS.companiesMine, { params });
  return response.data;
}

export async function userCompanies(userId = "me") {
  const response = await apiClient.get(userCompaniesUrl(userId));
  return response.data;
}

export async function permissions() {
  const response = await apiClient.get(RBAC_ENDPOINTS.permissions);
  return response.data;
}

export async function rolesList(params = {}) {
  const response = await apiClient.get(RBAC_ENDPOINTS.roles, { params });
  return response.data;
}

export async function createRole(payload) {
  const response = await apiClient.post(RBAC_ENDPOINTS.roles, payload);
  return response.data;
}

export async function updateRole(id, payload) {
  const response = await apiClient.patch(detailUrl(RBAC_ENDPOINTS.roles, id), payload);
  return response.data;
}

export async function rolesByCompany(companyId) {
  const response = await apiClient.get(rolesByCompanyUrl(companyId));
  return response.data;
}

export async function getRolesByCompany(companyId) {
  return rolesByCompany(companyId);
}

export async function assignUserCompany(payload) {
  const response = await apiClient.post(assignUserCompanyUrl, payload);
  return response.data;
}

export const RBAC = {
  companies: {
    list: listCompanies,
    create: createCompany,
    update: updateCompany,
    toggleActive: toggleCompanyActive,
    delete: deleteCompany,
  },
  companiesMine,
  userCompanies,
  permissions,
  rolesList,
  createRole,
  updateRole,
  rolesByCompany,
  getRolesByCompany,
  assignUserCompany,
};

export const rbacService = {
  listCompanies,
  createCompany,
  updateCompany,
  toggleCompanyActive,
  deleteCompany,
  companiesMine,
  userCompanies,
  permissions,
  rolesList,
  createRole,
  updateRole,
  rolesByCompany,
  getRolesByCompany,
  assignUserCompany,
};

export default rbacService;
